
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import './Products.css'
// import ShoppingCartHook from '@hooks/ShoppingCart.hook'
import { getStoreServiceCategories } from '@services/api.business.service'
import LoadingSection from '@components/LoadingSection'
import { useQuery } from '@tanstack/react-query'
// import ItemCard from '../../zearch/components/ItemCard'
import SectionTitle from './SectionTitle'
import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Space } from 'antd'
import { setStoreProfileServiceCategory } from '@reducers/contentReducer'


/**
 * NearProducts fetches and displays a list of products that are near the user's location.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.setIsShowRecommended - The function to set the visibility of recommended products (no longer used).
 * @param {Array} props.searchHistory - The user's search history.
 * @returns {JSX.Element} The JSX code for the NearProducts component.
 */
export default function StoreServiceCategoriesHeader({
    storeProfileId,
}) {
    const dispatch = useDispatch()
    const selectedCategory = useSelector(state => state.content.storeProfileServiceCategory)

    const storeCategoryRef = React.useRef(null)

    const {
        isPending,
        // error,
        data,
    } = useQuery({
        queryKey: ['getStoreServiceCategories', storeProfileId],
        queryFn: () => getStoreServiceCategories({
            business_id: storeProfileId,
            // is_recommended: true,
            // is_image: 'true'
        }),
    })

    const onClickScrollBtn = (step) => {
        if (!storeCategoryRef.current)
            return
        let scrollAmount = 0
        const slideTimer = setInterval(() => {
            storeCategoryRef.current.scrollLeft += step
            scrollAmount += Math.abs(step)
            if (scrollAmount >= 1000) {
                clearInterval(slideTimer)
            }
        }, 20)
    }

    if (isPending)
        return <LoadingSection text='Loading Store Categories' height='200px' />

    const storeCategories = data?.data || []
    // const storeCategories = TestCategories
    if (storeCategories.length === 0)
        return null

    function setSelectedCategory(categoryId) {
        dispatch(setStoreProfileServiceCategory(categoryId))
    }

    if (!selectedCategory) {
        setSelectedCategory(storeCategories[0]?.children[0]?._id || storeCategories[0]?._id)
    }

    return (
        // <section
        //     style={{
        //         maxWidth: '100%'
        //     }}
        //     className="w-full flex flex-col relative"
        // // className={`w-full relative`}
        // >
        <div className='w-full flex-row items-center justify-center smsize:!justify-start overflow-x-auto phone:gap-[40px] less1400:overflow-x-scroll less1400:justify-center  less1400:gap-[20px] flex h-[50px] phone:h-[45px] gap-3 overflow-y-hidden bg-[#454545] px-[20px] border-t-2 border-[#C8C8C8]  smsize:px-0'>
            {/* <span className='scroll-left' style={{ top: '50px' }} onClick={() => onClickScrollBtn(-50)}><AiOutlineLeft /></span>
                <span className='scroll-right' style={{ top: '50px' }} onClick={() => onClickScrollBtn(50)}><AiOutlineRight /></span> */}
            {storeCategories?.map((category, index) => (
                <Dropdown
                    key={index}
                    overlayStyle={{
                        textAlign: 'left',
                        color: '#fff'
                    }}
                    menu={{
                        items: category?.children?.map((child) => ({
                            key: child?._id,
                            label: (
                                <span
                                    onClick={(e) => {
                                        // e.preventDefault()
                                        setSelectedCategory(child?._id)
                                        const element = document.getElementById('store-service')
                                        if (element) {
                                            const yOffset = -200 // 向上偏移500px
                                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
                                            window.scrollTo({ top: y, behavior: 'smooth' })
                                        }
                                    }}

                                >
                                    {child?.title}
                                </span>
                            ),
                        })),
                    }}>
                    {/* <a onClick={e => {
                        e.preventDefault()
                        if (!category?.children?.length) {
                            setSelectedCategory(category?._id)
                        }
                    }}>
                        <Space style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            {category?.title}
                            {category?.children?.length > 0 && (
                                <DownOutlined />
                            )}
                        </Space>
                    </a> */}
                    <span
                        className='cursor-pointer whitespace-nowrap h-full flex items-center justify-center text-white hover:text-[#f3f3f3] px-5 sm:px-2 font-light text-[13px] font-lexend color-black hover:scale-105 transition-transform duration-150 ease-in-out'
                        key={category?._id}
                        onClick={() => {
                            if (!category?.children?.length) {
                                setSelectedCategory(category?._id)
                                // scroll to id = service-list y-200
                                const element = document.getElementById('store-service')
                                if (element) {
                                    // scroll to the element - 200px
                                    // element.scrollIntoView({
                                    //     behavior: 'smooth',
                                    //     block: 'start',
                                    //     inline: 'nearest'
                                    // })
                                    const yOffset = -200 // 向上偏移500px
                                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
                                    window.scrollTo({ top: y, behavior: 'smooth' })

                                }
                            }
                        }}
                    >
                        {category?.title}
                        {category?.children?.length > 0 && (
                            <DownOutlined />
                        )}
                    </span>
                </Dropdown>
            ))}
        </div>
        // </div>
        // </section>
    )
}
